import {
  ChangeDetectionStrategy, Component, EventEmitter,
  Input, OnChanges, Output, SimpleChanges, signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MeetingDetailTableComponent } from '../../../../shared/components/meeting-detail-table/meeting-detail-table.component';
import { GuestWizardComponent } from '../../../../shared/components/guest-wizard/guest-wizard.component';
import { TimezoneSelectComponent } from '../../../../shared/components/timezone-select/timezone-select.component';
import { AddParticipantsDetails, AddedGuest, ContactItem } from '../../models/pcheck.model';
import { browserTimezone, isIsoUtc } from '../../helpers/booking-timezone';

@Component({
  selector: 'app-add-participants-card',
  standalone: true,
  imports: [CommonModule, MeetingDetailTableComponent, GuestWizardComponent, TimezoneSelectComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './add-participants-card.component.html',
  styleUrls: ['./add-participants-card.component.scss'],
})
export class AddParticipantsCardComponent implements OnChanges {
  @Input() details!: AddParticipantsDetails;
  /** SF contacts for the wizard — undefined = loading, [] = none available. */
  @Input() contacts?: ContactItem[];
  @Input() confirmed = false;
  @Input() addedParticipants?: string[];
  @Input() dismissed = false;

  @Output() participantsConfirmed = new EventEmitter<string[]>();
  @Output() cancelled             = new EventEmitter<void>();

  readonly started   = signal(false);
  // Default to the meeting's recorded timezone (the executive's configured zone,
  // or PST when unset — supplied by the backend), falling back to the browser's
  // local zone only if the backend sent none. The user can still switch zones.
  readonly displayTz = signal(browserTimezone());

  /** Show the timezone picker only for UTC ISO times (regular pcheck). */
  get showTzPicker(): boolean { return isIsoUtc(this.details?.start_time); }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['details'] && this.details?.timezone) {
      this.displayTz.set(this.details.timezone);
    }
  }

  onTimezoneChange(tz: string): void { this.displayTz.set(tz); }

  onStart(): void {
    this.started.set(true);
  }

  onDismiss(): void {
    this.cancelled.emit();
  }

  onGuestsConfirmed(guests: AddedGuest[]): void {
    this.participantsConfirmed.emit(guests.map(g => g.email));
  }
}
